import { createReducer, on } from "@ngrx/store";
import { initialLearnerReportState, LearnerReportState } from "./learner-report.state";
import { ResetReportState, GetLearnerReportTypes, GetLearnerReportTypesSuccess, GetLearnerReportTypesError, UpdateReportSessionFilter, UpdateReportSessionFilterSuccess, UpdateReportSessionFilterError, ResetReportSessionFilterState, GetReportsFilter, GetReportsFilterSuccess, GetReportsFilterError, ResetGetReportsFilter, GenerateReports, GenerateReportsSuccess, GenerateReportsError, GetReportsTableResult, GetReportsTableResultSuccess, GetReportsTableResultError, GetReportDetails, GetReportDetailsSuccess, GetReportDetailsError, UpdateTableReportByParams, UpdateTableReportByParamsSuccess, UpdateTableReportByParamsError, GetLearnerReportListLength, GetLearnerReportListLengthSuccess, GetLearnerReportListLengthError, GetLearnerReportsChart, GetLearnerReportsChartSuccess, GetLearnerReportsChartError, ResetLearnerReportsChart, ExportReportsTable, ExportReportsTableSuccess, ExportReportsTableError, ResetLearnerReportTable, ResetLearnerReportTableSuccess, ResetLearnerReportTableError } from "./learner-report.actions";
import { Levels } from "src/app/constants/LevelConstants";
import { AppConstants } from "src/app/constants/constants";

export const LearnerReportReducers = createReducer(
  initialLearnerReportState,
  on(ResetReportState, (_): LearnerReportState => {
    return initialLearnerReportState
  }),
  on(GetLearnerReportTypes, (state): LearnerReportState => {
    return {
      ...state,
      reportTypes: null,
      reportTypesLoader: true,
      reportTypesError: null,
    }
  }),
  on(GetLearnerReportTypesSuccess, (state, action): LearnerReportState => {
    return {
      ...state,
      reportTypes: action.result,
      reportTypesLoader: false,
      reportTypesError: null,
    }
  }),
  on(GetLearnerReportTypesError, (state, action): LearnerReportState => {
    return {
      ...state,
      reportTypesLoader: false,
      reportTypesError: action.error,
    }
  }),
  on(UpdateReportSessionFilter, (state): LearnerReportState => {
    return {
      ...state,
      updateReportFilter: null,
      updateReportFilterLoader: true,
      updateReportFilterError: null,
    }
  }),
  on(UpdateReportSessionFilterSuccess, (state, action): LearnerReportState => {
    return {
      ...state,
      updateReportFilter: action.result,
      updateReportFilterLoader: false
    }
  }),
  on(UpdateReportSessionFilterError, (state, action): LearnerReportState => {
    return {
      ...state,
      updateReportFilterLoader: false,
      updateReportFilterError: action.error,
    }
  }),
  on(ResetReportSessionFilterState, (state): LearnerReportState => {
    return {
      ...state,
      updateReportFilter: null,
      updateReportFilterLoader: false,
      updateReportFilterError: null,
    }
  }),
  on(GetReportsFilter, (state): LearnerReportState => {
    return {
      ...state,
      getReportsFilter: null,
      getReportsFilterLoader: true,
      getReportsFilterError: null,
    }
  }),
  on(GetReportsFilterSuccess, (state, action): LearnerReportState => {
    return {
      ...state,
      getReportsFilter: action.reportsFilter,
      getReportsFilterLoader: false,
    }
  }),
  on(GetReportsFilterError, (state, action): LearnerReportState => {
    return {
      ...state,
      getReportsFilterLoader: false,
      getReportsFilterError: action.error,
    }
  }),
  on(ResetGetReportsFilter, (state): LearnerReportState => {
    return {
      ...state,
      getReportsFilter: null,
      getReportsFilterLoader: false,
      getReportsFilterError: null,
    }
  }),
  on(GenerateReports, (state): LearnerReportState => {
    return {
      ...state,
      generateReportResult: null,
      generateReportLoader: true,
      generateReportError: null,
    }
  }),
  on(GenerateReportsSuccess, (state, action): LearnerReportState => {
    return {
      ...state,
      generateReportResult: action.result,
      generateReportLoader: false,
    }
  }),
  on(GenerateReportsError, (state, action): LearnerReportState => {
    return {
      ...state,
      generateReportLoader: false,
      generateReportError: action.error,
    }
  }),
  on(GetReportsTableResult, (state): LearnerReportState => {
    return {
      ...state,
      reportsTableResult: null,
      reportsTableLoader: true,
      reportsTableError: null
    }
  }),
  on(GetReportsTableResultSuccess, (state, action): LearnerReportState => {
    return {
      ...state,
      reportsTableResult: action.result,
      reportsTableLoader: false,
    }
  }),
  on(GetReportsTableResultError, (state, action): LearnerReportState => {
    return {
      ...state,
      reportsTableLoader: false,
      reportsTableError: action.error,
    }
  }),
  on(GetReportDetails, (state): LearnerReportState => {
    return {
      ...state,
      reportDetails: null,
      reportDetailsLoader: true,
      reportDetailsError: null,
    }
  }),
  on(GetReportDetailsSuccess, (state, action): LearnerReportState => {
    return {
      ...state,
      reportDetails: action.result,
      reportDetailsLoader: false
    }
  }),
  on(GetReportDetailsError, (state, action): LearnerReportState => {
    return {
      ...state,
      reportDetailsError: action.error,
      reportDetailsLoader: false
    }
  }),
  on(UpdateTableReportByParams, (state): LearnerReportState => {
    return {
      ...state,
      updateTableReportResult: null,
      updateTableReportLoader: true,
      updateTableReportError: null,
    }
  }),
  on(UpdateTableReportByParamsSuccess, (state, action): LearnerReportState => {
    return {
      ...state,
      updateTableReportResult: action.result,
      updateTableReportLoader: false,
    }
  }),
  on(UpdateTableReportByParamsError, (state, action): LearnerReportState => {
    return {
      ...state,
      updateTableReportLoader: false,
      updateTableReportError: action.error,
    }
  }),
  on(GetLearnerReportListLength, (state): LearnerReportState => {
    return {
      ...state,
      learnerReportListLength: null,      
      learnerReportListLengthLoader: true,
      learnerReportListLengthError: null
    }
  }),
  on(GetLearnerReportListLengthSuccess, (state, action): LearnerReportState => {
    return {
      ...state,
      learnerReportListLength: action.result,
      learnerReportListLengthLoader: false,
    }
  }),
  on(GetLearnerReportListLengthError, (state, action): LearnerReportState => {
    return {
      ...state,
      learnerReportListLengthLoader: false,
      learnerReportListLengthError: action.error
    }
  }),
  on(GetLearnerReportsChart, (state): LearnerReportState => {
    return {
      ...state,
      reportsChart: null,
      reportsChartLoader: true,
      reportsChartError: null
    }
  }),
  on(GetLearnerReportsChartSuccess, (state, action): LearnerReportState => {
    return {
      ...state,
      reportsChart: action.result,
      reportsChartLoader: false,
    }
  }),
  on(GetLearnerReportsChartError, (state, action): LearnerReportState => {
    return {
      ...state,
      reportsChartError: action.error,
      reportsChartLoader: false,
    }
  }),
  on(ResetLearnerReportsChart, (state): LearnerReportState => {
    return {
      ...state,
      reportsChart: null,
      reportsChartLoader: false,
      reportsChartError: null
    }
  }),
  on(ExportReportsTable, (state): LearnerReportState => {
    return {
      ...state,
      exportReportsTable: null,
      exportReportsTableLoader: true,
      exportReportsTableError: null,
    }
  }),
  on(ExportReportsTableSuccess, (state, action): LearnerReportState => {
    return {
      ...state,
      exportReportsTable: action.result.map(report => {
        if(report.overall)
        {
          return { ...report, overall: report?.overall == Levels.Pre_Entry.toUpperCase() ? AppConstants.PRE_ENTRY : report?.overall } 
        }

        return report;
      }),
      exportReportsTableLoader: false,
    }
  }),
  on(ExportReportsTableError, (state, action): LearnerReportState => {
    return {
      ...state,
      exportReportsTableLoader: false,
      exportReportsTableError: action.error,
    }
  }),
  on(ResetLearnerReportTable, (state): LearnerReportState => {
    return {
      ...state,
      resetLearnerTable: null,
      resetLearnerTableLoader: true,
      resetLearnerTableError: null,

      //Reset generating reports states
      generateReportResult: null,
      generateReportLoader: false,
      
      //Reset stored data as well
      reportsTableResult: null,
    }
  }),
  on(ResetLearnerReportTableSuccess, (state, action): LearnerReportState => {
    return {
      ...state,
      resetLearnerTable: action.result,
      resetLearnerTableLoader: false,
    }
  }),
  on(ResetLearnerReportTableError, (state, action): LearnerReportState => {
    return {
      ...state,
      resetLearnerTableLoader: false,
      resetLearnerTableError: action.error,
    }
  }),
);